<template>
  <div class="search-page">
    <page-header />
    <page-main />
  </div>
</template>
<script>
import PageHeader from '../search-page/views/page-header/page-header.vue'
import PageMain from './page-main/page-main.vue'
export default {
  name: 'UploadPageEducation',
  components: { PageHeader, PageMain },
  provide() {
    return { title: '能力升级', tip: '中级、高级鉴定师能力等级申请', type: 2 }
  },
  mounted() {
    document.title = '中国检验认证集团浙江有限公司-鉴定能力升级'
  }
}
</script>
